import { render, staticRenderFns } from "./rightMenu.vue?vue&type=template&id=51fc650d&scoped=true&"
import script from "./rightMenu.vue?vue&type=script&lang=js&"
export * from "./rightMenu.vue?vue&type=script&lang=js&"
import style0 from "./rightMenu.vue?vue&type=style&index=0&id=51fc650d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fc650d",
  null
  
)

export default component.exports